import React from "react"

export default function Footer() {
  return <footer id="ubc7-footer" className="expand" role="contentinfo">
    <div className="row-fluid expand" id="ubc7-global-footer">
      <div className="container">
        <div className="span5" id="ubc7-signature"><a href="https://www.ubc.ca/" title="The University of British Columbia (UBC)">The University of British Columbia</a></div>
        <div className="span7" id="ubc7-footer-menu">
          <div className="row-fluid">
            <div className="span6">
              <h3>About UBC</h3>
              <div><a href="https://www.ubc.ca/about/contact.html">Contact UBC</a></div>
              <div><a href="https://www.ubc.ca/about/">About the University</a></div>
              <div><a href="https://www.ubc.ca/landing/news.html">News</a></div>
              <div><a href="https://www.ubc.ca/landing/events.html">Events</a></div>
              <div><a href="https://hr.ubc.ca/careers-and-job-postings">Careers</a></div>
              <div><a href="https://give.ubc.ca/">Make a Gift</a></div>
              <div><a href="https://www.ubc.ca/search/">Search UBC.ca</a></div>
            </div>
            <div className="span6">
              <h3>UBC Campuses</h3>
              <div><a href="https://www.ubc.ca/">Vancouver Campus</a></div>
              <div><a href="https://ok.ubc.ca/">Okanagan Campus</a></div>
              <h4>UBC Sites</h4>
              <div><a href="https://robsonsquare.ubc.ca/">Robson Square</a></div>
              <div><a href="https://thecdm.ca/">Centre for Digital Media</a></div>
              <div><a href="https://www.med.ubc.ca/about/campuses/">Faculty of Medicine Across BC</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="row-fluid expand" id="ubc7-minimal-footer">
      <div className="container">
        <div className="span12">
          <ul>
            <li>
              <a href="//cdn.ubc.ca/clf/ref/emergency" title="Emergency Procedures">Emergency Procedures</a>
              {' '}
              <span className="divider">|</span>
            </li>
            <li>
              <a href="//cdn.ubc.ca/clf/ref/terms" title="Terms of Use">Terms of Use</a>
              {' '}
              <span className="divider">|</span>
            </li>
            <li>
              <a href="//cdn.ubc.ca/clf/ref/copyright" title="UBC Copyright">Copyright</a>
              {' '}
              <span className="divider">|</span>
            </li>
            <li><a href="//cdn.ubc.ca/clf/ref/accessibility" title="Accessibility">Accessibility</a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
}
